export default __webpack_public_path__ + "83e7a0ab5dc3177d4723c673cf4fa1fb.woff";